import React, { ReactElement } from "react"
import {
	Breadcrumb,
	BreadcrumbItem,
} from "@walmart-web/livingdesign-components"
import "./index.css"
import { useHistory } from "react-router-dom"
import { IntlShape } from "react-intl"

const ContextualHeader = ({
	hint,
	breadcrumbs,
}: ContextualHeaderProps): ReactElement => {
	const history = useHistory()

	return (
		<div role="contextual-header" className="context-header">
			<div className="title">
				{!!breadcrumbs.length && (
					<Breadcrumb>
						{breadcrumbs.map(({ name, path }, i) => {
							const isCurrentPath = i === breadcrumbs.length - 1

							return (
								<BreadcrumbItem
									key={i}
									href=""
									onClick={(e) => {
										e.preventDefault()
										!isCurrentPath && !!path && history.push(path)
									}}
									isCurrent={isCurrentPath}
								>
									{name}
								</BreadcrumbItem>
							)
						})}
					</Breadcrumb>
				)}
			</div>
			{hint && (
				<div className="subtitle">
					<div className="hint">(*) {hint}</div>
				</div>
			)}
			<div style={{ clear: "both" }} />
		</div>
	)
}

export const createBreadcrumbsTranslated = (
	intl: IntlShape,
	breadcrumbs: Array<{ id: string; path?: string }>
): Array<BreadcrumbProps> =>
	breadcrumbs.map(({ id, path }) => ({
		name: intl.formatMessage({ id }),
		path,
	}))

interface BreadcrumbProps {
	name: string
	path?: string
}

interface ContextualHeaderProps {
	hint?: string
	breadcrumbs: Array<BreadcrumbProps>
}

export default ContextualHeader
